<template>
    <div class="content_btn_wrap text_center mt15">
        <el-button type="primary" @click="submitForm()">저장</el-button>

<!--        <el-button class="float_right " type="danger"
                   @click="openOrderReasonModal('orderRefund')">
            환불
        </el-button>
        <el-button class="float_right " type="danger"
                   @click="openOrderReasonModal('orderChange')">
            교환
        </el-button>-->
        <el-button class="float_right" type="primary" v-if="orderData.orderStatus === 50" @click="sendUpdateStatus(60)">구매확정 처리</el-button>
        <div class="clear"></div>
    </div>
</template>

<script>

import orderMixins from "@/mixins/orderMixins";

export default {
    name: "ShippingDoneSaveLayout",
    mixins: [orderMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        runWrite: {
            default: () => {
            }, type: Function
        },
        orderKey: {default:0},
        orderData: {default: () => {}},
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        sendUpdateStatus(type){
            let params ={
                c_status: type,
                c_idx :this.orderKey.toString(),
            }
            this.updateStatus(params)
        },
        submitForm() {
            this.runWrite();
        },
        openOrderReasonModal(type) {
            this.$modal.show('order-reason-modal',{type : type,key: this.orderKey.toString()})
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
